import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplicationState } from '@/StateManagement/ReduxStore';
import { parseArray } from '@/utility/parseArray';

export interface User {
  readonly id: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly country?: string;
  readonly businessName?: string;
  readonly calizaBenefits?: readonly string[];
  readonly integratorId?: string;
  readonly beneficiaryId?: string;

  completedKYB?: boolean;

  readonly sessionId?: string;
  readonly accessToken: string;
}

export class User {
  public static fromKeycloakToken(rawToken: string, tokenParsed: Record<string, string>): User {
    return {
      id: tokenParsed.id ?? tokenParsed['user-id'],
      email: tokenParsed.email,
      firstName: tokenParsed.given_name,
      lastName: tokenParsed.family_name,
      country: tokenParsed.country,
      businessName: tokenParsed.businessName,
      calizaBenefits: parseArray(tokenParsed.calizaBenefits),
      integratorId: tokenParsed['integrator-id'],
      beneficiaryId: tokenParsed['beneficiary-id'],
      accessToken: rawToken,
      sessionId: tokenParsed.sid,
    };
  }
}

export interface AuthState {
  user: User | null;
}

const initialState: AuthState = {
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setUser: (state: AuthState, action: PayloadAction<User | null>): void => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = authSlice.actions;

export const authSelector = (state: ApplicationState): AuthState => state.auth;

export default authSlice.reducer;
